/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var Icon_1 = require("./Icon");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ProgressNavigation.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-progressNavigation");
exports.ProgressNavigation = function ProgressNavigation(_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("nav", { className: classnames(moduleClassName(), className) }, children));
};
exports.ProgressNavigationLink = function ProgressNavigationLink(_a) {
    var title = _a.title, onClick = _a.onClick, className = _a.className, active = _a.active, status = _a.status;
    var _b;
    return (React.createElement("a", { href: "#", onClick: onClick, className: classnames(moduleClassName("link"), (_b = {},
            _b[moduleClassName("isActive")] = active,
            _b[moduleClassName("isComplete")] = status === "complete",
            _b[moduleClassName("isIncomplete")] = status === "incomplete",
            _b), className) },
        title,
        React.createElement("span", { className: moduleClassName("checkIcon") }, status === "complete" ? (React.createElement(Icon_1.Icon, { type: "check-small-filled" })) : (React.createElement(Icon_1.Icon, { type: "warning-small-filled" })))));
};
exports.ProgressNavigationLink.propTypes = {
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    active: PropTypes.bool,
    status: PropTypes.oneOf([
        "none",
        "complete",
        "incomplete"
    ]).isRequired
};